import { useLocation, useNavigate } from "react-router-dom";

type Item = {
  label: string;
  icon: string;
  hasChevron?: boolean;
  route?: string;
};

const items: Item[] = [
  { label: "Actions", icon: "actions", hasChevron: true },
  { label: "Summary", icon: "summary", hasChevron: true },
  { label: "Workplan", icon: "workplan" },
  { label: "Loss Details", icon: "loss", hasChevron: true },
  { label: "Exposures", icon: "exposures" },
  { label: "Reinsurance", icon: "reinsurance" },
  { label: "Parties Involved", icon: "parties", hasChevron: true },
  { label: "Policy", icon: "policy", hasChevron: true },
  { label: "Financials", icon: "financials", hasChevron: true },
  { label: "Notes", icon: "notes" },
  { label: "Documents", icon: "documents", route: "/documents" },
  { label: "Plan of Action", icon: "plan", hasChevron: true },
  { label: "Services", icon: "services", route: "/services" },
  { label: "Litigation", icon: "litigation" },
  { label: "History", icon: "history" },
  { label: "FNOL Snapshot", icon: "fnol", hasChevron: true },
  { label: "Calendar", icon: "calendar", hasChevron: true },
];

function getIconSvg(name: string) {
  const common = { width: 14, height: 14, viewBox: "0 0 16 16", fill: "currentColor" };
  switch (name) {
    case "actions":
      return (
        <svg {...common}>
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM3 4h10v1H3V4zm0 3h10v1H3V7zm0 3h7v1H3v-1z" />
        </svg>
      );
    case "summary":
      return (
        <svg {...common}>
          <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zM4.5 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0-4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z" />
        </svg>
      );
    case "workplan":
      return (
        <svg {...common}>
          <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h11A1.5 1.5 0 0 1 15 2.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5H7v1H2.5A1.5 1.5 0 0 1 1 13.5v-11zM4 4h8v1H4V4zm0 2h8v1H4V6zm0 2h4v1H4V8z" />
          <path d="M15 11.5A1.5 1.5 0 0 1 13.5 13H11l-2 2v-2H8.5A1.5 1.5 0 0 1 7 11.5v-2A1.5 1.5 0 0 1 8.5 8h5A1.5 1.5 0 0 1 15 9.5v2z" />
        </svg>
      );
    case "loss":
      return (
        <svg {...common}>
          <path d="M7.001 14s-1-1-1-7c0-3.5 1.5-5 3-5 .82 0 1.5.5 2 1 .501-.5 1.18-1 2-1 1.5 0 3 1.5 3 5 0 6-1 7-1 7H7zM1 2.5A1.5 1.5 0 0 1 2.5 1h2A1.5 1.5 0 0 1 6 2.5v2A1.5 1.5 0 0 1 4.5 6h-2A1.5 1.5 0 0 1 1 4.5v-2zm1.5-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zM3 11h2v3H3v-3zm-2 0h1v3H1v-3zm5 0h1v3H6v-3z" />
        </svg>
      );
    case "exposures":
      return (
        <svg {...common}>
          <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12zm1-9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7.5 7h1v5h-1V7z" />
        </svg>
      );
    case "reinsurance":
      return (
        <svg {...common}>
          <path d="M8 0a8 8 0 1 0 8 8H8V0zm-1 7V1.07A7 7 0 0 0 1.07 7H7zM1.07 8H7v5.93A7 7 0 0 1 1.07 8z" />
        </svg>
      );
    case "parties":
      return (
        <svg {...common}>
          <path d="M5 3a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm9 7c0-1.6-2.7-2.9-6-2.9S2 8.4 2 10v2h12v-2z" />
        </svg>
      );
    case "policy":
      return (
        <svg {...common}>
          <path d="M3 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H3zm1 3h8v1H4V3zm0 2h8v1H4V5zm0 2h5v1H4V7z" />
        </svg>
      );
    case "financials":
      return (
        <svg {...common}>
          <path d="M0 14h2V8H0v6zm4 0h2V4H4v10zm4 0h2v-4H8v4zm4 0h2V0h-2v14zM0 16h16v-1H0v1z" />
        </svg>
      );
    case "notes":
      return (
        <svg {...common}>
          <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm1 4h6v1H5V4zm0 2h6v1H5V6zm0 2h6v1H5V8zm0 2h4v1H5v-1z" />
        </svg>
      );
    case "documents":
      return (
        <svg {...common}>
          <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5l-5-5H4zm5 1.5L13 5h-3a1 1 0 0 1-1-1V1.5zM5 8h6v1H5V8zm0 2h6v1H5v-1zm0 2h4v1H5v-1z" />
        </svg>
      );
    case "plan":
      return (
        <svg {...common}>
          <path d="M6 1 6.5 0H8V1.5L7 2 6 1zm-2 1 1 1-1 1-1-1 1-1zm9-1.5L12 0V2L14 1.5l-1-1zM2 6l1-1 1 1-1 1-1-1zM6 7.5 8 6l2 2-2 1-2-2zm8.5 1.5-1-1L14 7l1.5 1L14.5 9zM2 11l1-1 1 1-1 1-1-1zm12-1 1 1-1 1-1-1 1-1zM7 12l1 1V14H6V12h1zm-3 2 1-1 1 1-1 1-1-1zm8 0-1-1 1-1 1 1-1 1z" />
        </svg>
      );
    case "services":
      return (
        <svg {...common}>
          <path d="M9 3a3 3 0 0 1 4 3l-3 3-1-1 3-3a2 2 0 0 0-2-2L9 3zM3 9l3 3a2 2 0 0 0 2 2l1-1-3-3-3-1zm10.5 4.5L10 17l-1 1H8V16l1-1 3.5-3.5 1 1z" transform="rotate(-45 8 8)"/>
        </svg>
      );
    case "litigation":
      return (
        <svg {...common}>
          <path d="M8 0a1 1 0 0 1 1 1v.5h6V3H1V1.5h6V1a1 1 0 0 1 1-1zM1 4h14v1l-2 8a2 2 0 0 1-2 1.5h-2V14h2a1 1 0 0 0 .8-.4L13 6h-3.5l-1 6h-1l-1-6H3l1.2 7.6a1 1 0 0 0 .8.4h2v1.5H5a2 2 0 0 1-2-1.5L1 5v-1z" />
        </svg>
      );
    case "history":
      return (
        <svg {...common}>
          <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12zm.5-9.5H7v5h4V8H8.5V4.5z" />
        </svg>
      );
    case "fnol":
      return (
        <svg {...common}>
          <path d="M3 0a2 2 0 0 0-2 2v13l5-3 5 3V2a2 2 0 0 0-2-2H3zm10 0a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H11l1-1h1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-1l-1-1h2z" />
        </svg>
      );
    case "calendar":
      return (
        <svg {...common}>
          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
        </svg>
      );
    default:
      return null;
  }
}

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const isVoltaire = currentPath.startsWith("/voltaire");

  // On Voltaire popup pages, the "Actions" sidebar item is omitted
  const visibleItems = isVoltaire ? items.filter((i) => i.label !== "Actions") : items;

  return (
    <div className="sidebar">
      {visibleItems.map((item) => {
        const isActive =
          (item.route && currentPath === item.route) ||
          (item.label === "Services" && isVoltaire);
        const isActionActive = item.label === "Actions" && !isVoltaire;

        return (
          <div
            key={item.label}
            className={`sidebar-item ${isActive ? "active" : ""} ${
              isActionActive && currentPath === "/services" ? "active-action" : ""
            }`}
            onClick={() => item.route && navigate(item.route)}
          >
            <span className="item-icon">{getIconSvg(item.icon)}</span>
            <span>{item.label}</span>
            {item.hasChevron && <span className="chevron">▸</span>}
          </div>
        );
      })}
      <div className="sidebar-collapse">«</div>
    </div>
  );
}
